function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { dequal } from 'dequal';
import warning from 'tiny-warning';
import pathToRegexp, { compile } from './pathToRegexp';
var Matcher = /*#__PURE__*/function () {
  function Matcher(routeConfig) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Matcher);
    this.routeConfig = routeConfig;
    this.options = Object.assign({
      warnOnPotentialMissingIndexRoutes: true,
      warnOnPartiallyMatchedNamedRoutes: true
    }, options);
  }
  return _createClass(Matcher, [{
    key: "match",
    value: function match(_ref) {
      var pathname = _ref.pathname;
      var matches = this.matchRoutes(this.routeConfig, pathname);
      if (!matches) {
        return null;
      }
      return this.makePayload(matches);
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(_ref2) {
      var routeIndices = _ref2.routeIndices;
      if (!routeIndices) {
        return null;
      }
      return this.getRoutesFromIndices(routeIndices, this.routeConfig);
    }
  }, {
    key: "joinPaths",
    value: function joinPaths(basePath, path) {
      if (!path) {
        return basePath;
      }
      if (basePath.charAt(basePath.length - 1) === '/') {
        // eslint-disable-next-line no-param-reassign
        basePath = basePath.slice(0, -1);
      }
      return "".concat(basePath).concat(this.getCanonicalPattern(path));
    }
  }, {
    key: "isActive",
    value: function isActive(_ref3, location) {
      var matchLocation = _ref3.location;
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$exact = _ref4.exact,
        exact = _ref4$exact === void 0 ? false : _ref4$exact;
      return this.isPathnameActive(matchLocation.pathname, location.pathname, exact) && this.isQueryActive(matchLocation.query, location.query);
    }
  }, {
    key: "format",
    value: function format(pattern, params) {
      return compile(pattern)(params);
    }
  }, {
    key: "matchRoutes",
    value: function matchRoutes(routeConfig, pathname) {
      for (var index = 0; index < routeConfig.length; ++index) {
        var route = routeConfig[index];
        var match = this.matchRoute(route, pathname);
        if (!match) {
          continue; // eslint-disable-line no-continue
        }

        var params = match.params,
          remaining = match.remaining;
        var children = route.children;
        if (children) {
          if (Array.isArray(children)) {
            var childMatches = this.matchRoutes(children, remaining);
            if (childMatches) {
              return [{
                index: index,
                params: params
              }].concat(_toConsumableArray(childMatches));
            }
            if (!remaining && route.allowAsIndex) {
              return [{
                index: index,
                params: params
              }];
            }
            if (this.options.warnOnPotentialMissingIndexRoutes) process.env.NODE_ENV !== "production" ? warning(remaining, "Route matching pathname \"".concat(pathname, "\" has child routes, but no index route causing it to 404.\n") + "If this is intended ignore this warning otherwise in order to resolve this route add `index` to the route object or add route with no `path` and a `Component` to it's `children`.\n" + 'This warning can be disabled by setting `warnOnPotentialMissingIndexRoutes` to `false` in the Matcher.') : void 0;
          } else {
            var groups = this.matchGroups(children, remaining, pathname);
            if (groups) {
              return [{
                index: index,
                params: params
              }, {
                groups: groups
              }];
            }
          }
        }
        if (!remaining && !children) {
          return [{
            index: index,
            params: params
          }];
        }
      }
      return null;
    }
  }, {
    key: "matchRoute",
    value: function matchRoute(route, pathname) {
      var routePath = route.path;
      if (!routePath) {
        return {
          params: {},
          remaining: pathname
        };
      }
      var pattern = this.getCanonicalPattern(routePath);
      var keys = [];
      var regexp = pathToRegexp(pattern, keys, {
        end: false
      });
      var match = regexp.exec(pathname);
      if (match === null) {
        return null;
      }
      var params = {};
      keys.forEach(function (_ref5, index) {
        var name = _ref5.name;
        var value = match[index + 1];
        params[name] = value && decodeURIComponent(value);
      });
      return {
        params: params,
        remaining: pathname.slice(match[0].length)
      };
    }
  }, {
    key: "matchGroups",
    value: function matchGroups(routeGroups, pathname, parentPathname) {
      var groups = {};
      var failedGroups = [];
      var abortEarly = process.env.NODE_ENV === 'production' || !this.options.warnOnPartiallyMatchedNamedRoutes;
      for (var _i = 0, _Object$entries = Object.entries(routeGroups); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          groupName = _Object$entries$_i[0],
          routes = _Object$entries$_i[1];
        var groupMatch = this.matchRoutes(routes, pathname);
        if (!groupMatch) {
          if (abortEarly) {
            return null;
          }
          failedGroups.push(groupName);
        } else {
          groups[groupName] = groupMatch;
        }
      }
      if (failedGroups.length) {
        process.env.NODE_ENV !== "production" ? warning(!this.options.warnOnPartiallyMatchedNamedRoutes, "Route matching pathname \"".concat(parentPathname, "\" only partially matched against its named child routes causing it to 404. ") + "The following named routes failed to match \"".concat(pathname, "\":\n\n") + "".concat(failedGroups.join(', '), "\n\n") + "If this is intended ignore this warning, otherwise the unmatched groups may need at catch all route \"path=(.*)?\".\n" + 'This warning can be disabled by setting `warnOnPartiallyMatchedNamedRoutes` to `false` in the Matcher.') : void 0;
        return null;
      }
      return groups;
    }
  }, {
    key: "getCanonicalPattern",
    value: function getCanonicalPattern(pattern) {
      return pattern.charAt(0) === '/' ? pattern : "/".concat(pattern);
    }
  }, {
    key: "makePayload",
    value: function makePayload(matches) {
      var _this = this;
      var routeMatch = matches[0];
      if ('groups' in routeMatch) {
        process.env.NODE_ENV !== "production" ? warning(matches.length === 1, "Route match with groups ".concat(Object.keys(routeMatch.groups).join(', '), " has children, which are ignored.")) : void 0;
        var groupRouteIndices = {};
        var routeParams = [];
        var _params = {};
        Object.entries(routeMatch.groups).forEach(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
            groupName = _ref7[0],
            groupMatches = _ref7[1];
          var groupPayload = _this.makePayload(groupMatches);

          // Retain the nested group structure for route indices so we can
          // reconstruct the element tree from flattened route elements.
          groupRouteIndices[groupName] = groupPayload.routeIndices;

          // Flatten route groups for route params matching getRoutesFromIndices
          // below.
          routeParams.push.apply(routeParams, _toConsumableArray(groupPayload.routeParams));

          // Just merge all the params depth-first; it's the easiest option.
          Object.assign(_params, groupPayload.params);
        });
        return {
          routeIndices: [groupRouteIndices],
          routeParams: routeParams,
          params: _params
        };
      }
      var index = routeMatch.index,
        params = routeMatch.params;
      if (matches.length === 1) {
        return {
          routeIndices: [index],
          routeParams: [params],
          params: params
        };
      }
      var childPayload = this.makePayload(matches.slice(1));
      return {
        routeIndices: [index].concat(_toConsumableArray(childPayload.routeIndices)),
        routeParams: [params].concat(_toConsumableArray(childPayload.routeParams)),
        params: Object.assign({}, params, childPayload.params)
      };
    }
  }, {
    key: "getRoutesFromIndices",
    value: function getRoutesFromIndices(routeIndices, routeConfigOrGroups) {
      var routeIndex = routeIndices[0];
      if (_typeof(routeIndex) === 'object') {
        // Flatten route groups to save resolvers from having to explicitly
        // handle them.
        var groupRoutes = [];
        for (var _i2 = 0, _Object$entries2 = Object.entries(routeIndex); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            groupName = _Object$entries2$_i[0],
            groupRouteIndices = _Object$entries2$_i[1];
          groupRoutes.push.apply(groupRoutes, _toConsumableArray(this.getRoutesFromIndices(groupRouteIndices, routeConfigOrGroups[groupName])));
        }
        return groupRoutes;
      }
      var route = routeConfigOrGroups[routeIndex];
      if (routeIndices.length === 1) {
        return [route];
      }
      return [route].concat(_toConsumableArray(this.getRoutesFromIndices(routeIndices.slice(1), route.children)));
    }
  }, {
    key: "isPathnameActive",
    value: function isPathnameActive(matchPathname, pathname, exact) {
      if (pathname === matchPathname) {
        return true;
      }
      if (exact) {
        // The above condition is necessary for an exact match.
        return false;
      }

      // Require that a partial match be followed by a path separator.
      var pathnameWithSeparator = pathname.slice(-1) !== '/' ? "".concat(pathname, "/") : pathname;

      // Can't use startsWith, as that requires a polyfill.
      return matchPathname.indexOf(pathnameWithSeparator) === 0;
    }
  }, {
    key: "isQueryActive",
    value: function isQueryActive(matchQuery, query) {
      if (!query) {
        return true;
      }
      return Object.entries(query).every(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];
        return Object.prototype.hasOwnProperty.call(matchQuery, key) ? dequal(matchQuery[key], value) : value === undefined;
      });
    }
  }, {
    key: "replaceRouteConfig",
    value: function replaceRouteConfig(routeConfig) {
      this.routeConfig = routeConfig;
    }
  }]);
}();
export { Matcher as default };